// extracted by mini-css-extract-plugin
export default {"container":"PreDefinedStatus_container__uOzMw","title":"PreDefinedStatus_title__tiu8g","subtitle":"PreDefinedStatus_subtitle__XK0F6","buttons":"PreDefinedStatus_buttons__jC3Tk"};